import { render, staticRenderFns } from "./shopdata.vue?vue&type=template&id=0c977971"
import script from "./shopdata.vue?vue&type=script&lang=js"
export * from "./shopdata.vue?vue&type=script&lang=js"
import style0 from "./shopdata.vue?vue&type=style&index=0&id=0c977971&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports